import React from 'react';

/**
 * Two-or-more-state radio-group toggle styled as a single rounded pill with
 * flush-joined buttons. Suitable for 2–3 mutually exclusive options where a
 * dropdown is overkill (e.g. "Headcount / Labor Hours", "Plan window / Full
 * timeline").
 *
 * Props:
 *   value     — currently selected option's `value`
 *   onChange  — (newValue) => void
 *   options   — Array<{ value, label }>
 */

const GROUP_STYLE = {
  display: 'inline-flex',
  border: '1px solid #d5d9d9',
  borderRadius: 6,
  overflow: 'hidden',
  background: '#ffffff'
};

const buttonStyle = (selected) => ({
  background: selected ? '#16191f' : 'transparent',
  color: selected ? '#ffffff' : '#5a6470',
  border: 'none',
  padding: '6px 14px',
  fontSize: 13,
  fontWeight: selected ? 600 : 500,
  cursor: 'pointer',
  transition: 'background 120ms ease, color 120ms ease'
});

/**
 * Marked up as a group of toggle buttons (not a radio group). Each option
 * uses `aria-pressed` to communicate state — this matches how a sighted user
 * actually interacts with the control (Tab to each visible button, click /
 * Space / Enter to activate). The radio-group pattern would require roving
 * tabindex + arrow-key navigation, which is overkill for 2–3 always-visible
 * options.
 */
const SegmentedControl = ({ value, options, onChange, ariaLabel }) => (
  <div style={GROUP_STYLE} role="group" aria-label={ariaLabel}>
    {options.map((opt) => (
      <button
        key={opt.value}
        type="button"
        aria-pressed={value === opt.value}
        onClick={() => onChange(opt.value)}
        style={buttonStyle(value === opt.value)}>
        {opt.label}
      </button>
    ))}
  </div>
);

export default SegmentedControl;
